import { Link } from 'react-router-dom';
import ListErrors from './ListErrors';
import React from 'react';
import agent from '../agent';
import { connect } from 'react-redux';
import Toggle from 'react-toggle'
import Loading from './widgets/Loading'
import {
    MASTER_ACCOUNT_MINT_LOADED,
    MASTER_ACCOUNT_MINT,
    MASTER_ACCOUNT_MINT_UNLOADED
} from '../constants/actionTypes';

const mapStateToProps = state => ({
    ...state.account,
    currentUser: state.common.currentUser
});

const mapDispatchToProps = dispatch => ({
    onLoad: payload =>
        dispatch({ type: MASTER_ACCOUNT_MINT_LOADED, payload }),
    onSubmit: (payload, key) => {
        dispatch({ type: MASTER_ACCOUNT_MINT, payload, key })
    },
    onUnload: () =>
        dispatch({ type: MASTER_ACCOUNT_MINT_UNLOADED })
});

class MasterAccountMint extends React.Component {
    constructor() {
        super();
        this.state = {
            amount: '',
        }
        this.updateState = field => ev => {
            const state = this.state;
            const newState = Object.assign({}, state, { [field]: ev.target.value });
            this.setState(newState);
        }
        this.submitForm = (amount) => ev => {
            ev.preventDefault();
            const key = this.props.match.params.key
            const payload = agent.Accounts.mintMasterAccount(this.props.match.params.key, amount);
            this.props.onSubmit(payload, key);
        }
    }
    componentWillMount() {
        this.props.onLoad(agent.Accounts.getMasterAccountByKey(this.props.match.params.key));
    }
    componentWillUnmount() {
        this.props.onUnload();
    }
    handleChange(key, event) {
        this.setState({ [key]: event.target.checked })
    }
    render() {
        if (!this.props.account) {
            return (
                <Loading />
            )
        }
        const amount = this.state.amount;
        

        return (
            <div class='pane'>
                <Link className="crumb" to="/masteraccounts">&laquo; back to master accounts</Link>
                <h1>Mint amount to master account</h1>
                <ListErrors errors={this.props.errors} />
                <form onSubmit={this.submitForm(amount)}>
                    <fieldset className="form">
                        <strong>Mint amount</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="10000000"
                                value={amount}
                                onChange={this.updateState('amount')} />
                        </fieldset>

                        <fieldset className="form-group">
                            <button
                                type="submit"
                                disabled={this.props.inProgress}>
                                Mint amount
                            </button>
                        </fieldset>
                    </fieldset>
                </form>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MasterAccountMint);



// WEBPACK FOOTER //
// ./src/components/MasterAccountMint.js